import ApiCrud from "./api-crud";

class FeriadoService extends ApiCrud {
  resource = "feriados";
  primaryKey = "idferiado";
}

export default new FeriadoService();
